import { Play, ShoppingCart } from "lucide-react";
import { SITE, IMAGES } from "../mock/mock";

function scrollTo(href) {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
}

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative overflow-hidden bg-[#5c2751] pt-14 pb-32 md:pt-20 md:pb-44"
    >
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-white/5 blur-3xl transform-gpu" />
      <div className="relative max-w-3xl mx-auto px-5 md:px-8 flex flex-col items-center text-center">
        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight text-white">
          Gérard Trèves la tortue de Compostelle
        </h1>
        <p className="mt-3 font-heading text-lg md:text-xl font-bold text-white/90">
          Marcher pour apprendre à aimer
        </p>

        <img
          src={IMAGES.bookCover}
          srcSet="/images/book-cover-460.webp 460w, /images/book-cover.webp 700w"
          sizes="(max-width: 640px) 260px, 400px"
          alt="Couverture du livre Marcher pour apprendre à aimer, de Gérard Trèves"
          width="700"
          height="687"
          fetchPriority="high"
          className="mt-8 w-64 sm:w-80 md:w-[400px] drop-shadow-[0_35px_70px_rgba(0,0,0,0.55)]"
        />

        <p className="mt-8 max-w-xl text-sm md:text-base text-white/80 leading-relaxed">
          {SITE.heroLead}
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            data-testid="hero-videos-btn"
            onClick={() => scrollTo("#videos")}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/70 px-6 py-3 text-sm font-semibold text-white hover:bg-white hover:text-[#5c2751] transition-colors"
          >
            <Play className="h-4 w-4" /> Voir les vidéos
          </button>
          <a
            href={SITE.amazonUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-buy-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#5c2751] hover:bg-white/90 transition-colors"
          >
            <ShoppingCart className="h-4 w-4" /> Acheter le livre
          </a>
        </div>
      </div>

      {/* Vague blanche en bas */}
      <div className="absolute bottom-0 inset-x-0 leading-none">
        <svg viewBox="0 0 1440 120" preserveAspectRatio="none" className="w-full h-[60px] md:h-[100px]" aria-hidden="true">
          <path fill="#ffffff" d="M0,64 C360,120 1080,0 1440,64 L1440,120 L0,120 Z" />
        </svg>
      </div>
    </section>
  );
}
